export class UomSelectOption {
  title: string
  message?: string
  default?: boolean
  code?: string
}

export interface UomPallets {
  numberOfUOMperPallet: number
  numberOfUOMforFullPallet: number
  numberOfUOMperLayer: number
  numberOfUOMforFullLayer: number
}
